import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

type SectionIconType = 'primary' | 'destructive' | 'warning' | 'muted';

const TYPE_CLASSES: Record<SectionIconType, string> = {
  primary: 'bg-primary/10 text-primary',
  destructive: 'bg-destructive/10 text-destructive',
  warning: 'bg-warning/10 text-warning',
  muted: 'bg-muted text-muted-foreground',
};

const SIZE_CLASSES = {
  md: 'size-8 text-sm',
  lg: 'size-12 text-xl',
} as const;

interface SectionIconProps {
  type?: SectionIconType | undefined;
  size?: keyof typeof SIZE_CLASSES | undefined;
  children?: ReactNode | undefined;
}

/**
 * Rounded square badge wrapping a FontAwesome icon — the round status glyph used
 * across the AI-processing popover / sheet / sections. Pass the icon as
 * children (e.g. `<FontAwesomeIcon .../>`).
 */
export function SectionIcon({
  type = 'primary',
  size = 'md',
  children,
}: SectionIconProps) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-md',
        TYPE_CLASSES[type],
        SIZE_CLASSES[size],
      )}
    >
      {children}
    </div>
  );
}
